module.exports = __webpack_public_path__ + "img/s2_data1.3739f956.png";